/* eslint-disable */
import { createApi } from '@reduxjs/toolkit/query/react'
import { USERSERVICE_BASE_URL } from '../../envVariables'
import { axiosBaseQuery, Response } from '../../api/BaseQuery'

// User Management data view model for frontend display
export interface UserApplicationData {
  firstName: string
  lastName: string
  name: string
  email: string
  address: string
  tool: string
  role: string
  status: string
  lastLogin: Date
}

// Filter options response interface for the filters endpoint
export interface FilterOptionsResponse {
  Tools: string[]
  Status: string[]
}

// Transform filter response from backend to frontend format
function transformFilterResponse(
  inputModel:
    | Response<Record<string, string[]>>
    | Record<string, string[]>
    | any,
): FilterOptionsResponse {
  // Handle both API wrapper response and direct object response
  const data = inputModel?.data || inputModel
  const outputData: FilterOptionsResponse = {
    Tools: Array.from(data?.tools || []),
    Status: Array.from(data?.status || []),
  }
  return outputData
}

// RTK Query API service for User Management endpoints
const userManagementSearchService = createApi({
  reducerPath: 'userManagementSearchService',
  tagTypes: ['userManagementFilters', 'userManagementUsers'],
  baseQuery: axiosBaseQuery({
    baseURL: USERSERVICE_BASE_URL,
  }),
  endpoints: (builder) => ({
    getClientAdminFilters: builder.query<FilterOptionsResponse, void>({
      query: () => ({
        url: '/api/v1/clientadmin/getclientadminfilters',
        method: 'get',
      }),
      transformResponse: (
        response:
          | Response<Record<string, string[]>>
          | Record<string, string[]>
          | any,
      ) => {
        return transformFilterResponse(response)
      },
      providesTags: ['userManagementFilters'],
    }),
    getClientAdminUsers: builder.query<
      UserApplicationData[],
      {
        searchString?: string
        toolFilters?: string[]
        statusFilters?: string[]
        pageNumber?: number
        pageSize?: number
      } | void
    >({
      query: (params) => ({
        url: '/api/v1/clientadmin/getusers',
        method: 'get',
        params: params || {},
      }),
      transformResponse: (response: Response<UserApplicationData[]>) => {
        // Initially returns empty array for mock implementation
        // Transform will be updated when real data integration is added
        return response?.data || []
      },
      providesTags: ['userManagementUsers'],
    }),
  }),
})

// Export generated hooks for use in React components
export const {
  useGetClientAdminFiltersQuery,
  useGetClientAdminUsersQuery,
  useLazyGetClientAdminFiltersQuery,
  useLazyGetClientAdminUsersQuery,
} = userManagementSearchService

// Export the service for store registration (both named and default)
export { userManagementSearchService }
export default userManagementSearchService
